/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/aria-role */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MdNotifications, MdAccountBalanceWallet } from 'react-icons/md';
import { FiShield, FiUser } from 'react-icons/fi';
import { IoLogOutOutline } from 'react-icons/io5';
import { GoPrimitiveDot } from 'react-icons/go';
import { HiOutlinePencilAlt, HiOutlineRefresh } from 'react-icons/hi';
import { PropsFromRedux } from '.';
import Dropdown from '../common/Dropdown';
import { USER } from '../../interfaces/auth.interface';
import { NOTIFICATION } from '../../interfaces/common.interface';
import avatar from '../../assets/icons/avatar.jpeg';
import { API_KEYS } from '../../interfaces/api';
import { useComponentVisible } from '../../hooks/useComponentVisible';

interface Props extends PropsFromRedux {
  inMobile?: boolean;
}

interface NotificationProps {
  notification: NOTIFICATION;
  updateNotification: (...args: any) => Promise<void>;
}

const Notification: React.FC<NotificationProps> = ({
  notification,
  updateNotification,
}) => {
  React.useEffect(
    () => () => {
      updateNotification(notification.NotificationId);
    },
    [notification.NotificationId, updateNotification]
  );

  return (
    <div className="text-sm border-b border-gray-100 p-2 font-medium">
      <p>{notification.Subject}</p>
      <p className="font-normal overflow-hidden whitespace-nowrap overflow-ellipsis">
        {notification.Message}
      </p>
    </div>
  );
};

const AuthHeaderMenu: React.FC<Props> = ({
  auth,
  inMobile,
  logOut,
  showModal,
  getNotifications,
  notifications,
  walletpinstatus,
  getWalletPinStatus,
  updateNotification,
  resetApi,
}) => {
  const isLoggedIn = auth?.success && auth?.response;
  const response: USER = auth?.response?.Object;
  const isActive = isLoggedIn && response?.IsActive;
  const [display, changeD] = useState(true);
  const [clicked, setClicked] = useState(false);
  // const [isOpenDropDown, setIsOpenDropdown] = useState(false)
  // const [isOpenDropDown] = useState(false)

  // ADDED
  const [activeDropdown, setActiveDropdown] = useState(false);

  const handleDropdownClick = () => {
    setActiveDropdown(!activeDropdown);
  };

  const handleMenuItemClick = () => {
    setActiveDropdown(false);
  };

  const { ref, isComponentVisible, setIsComponentVisible, closeDropdown } =
    useComponentVisible(false);

  // useEffect(() => {
  //   // console.log("isComponentVisible authHeader-- ", isComponentVisible)
  // }, [isComponentVisible])

  React.useEffect(
    () => () => {
      resetApi(API_KEYS.GET_WALLETPIN_STATUS);
    },
    [resetApi]
  );

  // const menuClick = () => {
  //   if(clicked == true){

  //   }
  // }
  React.useEffect(() => {
    if (clicked)
      setTimeout(() => {
        setClicked(false);
      }, 1000);
  });

  React.useEffect(() => {
    if (isActive) {
      getNotifications();
      getWalletPinStatus();
    }
  }, [getNotifications, getWalletPinStatus, isActive]);
  // }, [getNotifications, isActive]);

  React.useEffect(() => {
    if (isActive) {
      if (
        !walletpinstatus?.loading &&
        walletpinstatus?.success &&
        walletpinstatus?.response?.Object === false
      ) {
        showModal({
          component: 'WalletPinModal',
          modalProps: {
            contentLabel: 'Wallet Pin Modal',
          },
        });
      }
    }
  }, [
    isActive,
    walletpinstatus?.loading,
    walletpinstatus?.success,
    walletpinstatus?.response?.Object,
  ]);

  const notificationList: NOTIFICATION[] =
    notifications?.response?.Object || [];

  const unreadNotifications = notificationList?.filter((item) => !item.IsRead);

  //  console.log("header isComponentVisible-- ", isComponentVisible)

  return (
    <nav className="flex flex-wrap lg:flex-nowrap  ml-1 items-center justify-end w-full font-serif">
      {isLoggedIn && (
        <div
          className={`${
            // inMobile ? 'hidden lg:inline-block' : 'inline-block'
            inMobile ? 'hidden lg:inline-block' : 'inline-block'
          } mr-3`}
        >
          
          <Dropdown
            hideCaret
            toggleContent={() => (
              <div className="relative">
                <MdNotifications className="text-2xl text-gray-400" />
                {!!unreadNotifications.length && (
                  <GoPrimitiveDot className="absolute top-0 right-0 text-primary" />
                )}
              </div>
            )}
          >
            <div className="w-52 bg-white shadow-sm">
              {!unreadNotifications.length && (
                <div className="text-sm border-b border-gray-100 p-2 font-medium">
                  No Unread notifications
                </div>
              )}
              {
                !!unreadNotifications?.map((item) => (
                  <Notification
                    notification={item}
                    updateNotification={updateNotification}
                    key={item.NotificationId}
                  />
                ))
              }
            </div>
          </Dropdown>
        </div>
      )}

      {/* <Link
        to={{ pathname: 'https://www.gigl-go.com/merchantSignUp' }}
        target="_blank"
        style={{ borderRadius: 4 }}
        className={`w-full sm:w-auto mb-3 sm:mb-0 sm:mr-3 whitespace-nowrap overflow-hidden overflow-ellipsis
         bg-white border-black border text-sm text-secondary p-3 justify-center ${
           inMobile ? 'inline-block' : 'hidden lg:inline-block'
         }`}
      >
        Become a Delivery Partner
      </Link> */}
      <div className={`${inMobile ? 'lg:flex hidden' : 'lg:hidden flex'} `}>
        {isLoggedIn ? (
          <div onClick={handleDropdownClick} onKeyDown={handleDropdownClick}>
            <Dropdown
              toggleContent={() => (
                <div className="flex font-semibold items-center justify-center">
                  <div className="text-sm mr-4 text-left hidden sm:block">
                    <p>
                      {response.FirstName} {response.LastName}{' '}
                      {/* <span className="bg-secondary p-1 inline-block rounded text-white text-xs">
                      {response.Rank}
                    </span> */}
                    </p>
                  </div>
                  <div className="w-10 h-10 flex-shrink-0 bg-gray-400 rounded-full">
                    <img
                      className="w-full rounded-full border border-gray-200 h-full"
                      src={response.PictureUrl || avatar}
                      alt={response.UserName}
                    />
                  </div>
                </div>
              )}
              closeOnClick  // Make sure closeOnClick is set to true

            >
              <div  className="w-52">
                {isActive ? (
                  <>
                    <Link
                      // className={`${!clicked ? 'flex hover:bg-gray-100 items-center text-sm font-medium p-2' : 'hidden'}`}
                      className="flex hover:bg-gray-100 items-center text-sm font-medium p-2"
                      to="/my-profile"
                      // ref={ref}
                      // onClick={() => {
                      //   setIsComponentVisible(!isComponentVisible)
                      //   closeDropdown()
                      // }}
                      // onKeyDown={() => closeDropdown()}
                      onClick={handleMenuItemClick}
                      role="Escape"
                    >
                      <FiUser className="text-xl mr-4" />
                      My Profile
                    </Link>
                    <Link
                      //  className={`${!clicked ? 'flex hover:bg-gray-100 items-center text-sm font-medium p-2' : 'hidden'}`}
                      className="flex hover:bg-gray-100 items-center text-sm font-medium p-2"
                      to="/wallet"
                      // onClick={() => {
                      //   // setIsComponentVisible(false)
                      //   closeDropdown()
                      // }}
                      onClick={handleMenuItemClick}
                    >
                      <MdAccountBalanceWallet className="text-xl mr-4" />
                      My Transactions
                    </Link>

                    <button
                      type="button"
                      aria-label="logout"
                      // className={`${!clicked ? 'flex hover:bg-gray-100 items-center text-sm font-medium p-2' : 'hidden'}`}
                      className="flex items-center w-full  hover:bg-gray-100 text-sm font-medium p-2"
                      onClick={() => {
                        showModal({
                          component: 'ChangeWalletPin',
                          modalProps: {
                            contentLabel: 'Change Wallet Pin',
                          },
                        });
                        handleMenuItemClick();
                      }}
                    >
                      <HiOutlinePencilAlt className="text-xl mr-4" />
                      Change Wallet Pin
                    </button>

                    <button
                      type="button"
                      aria-label="logout"
                      // className={`${!clicked ? 'flex hover:bg-gray-100 items-center text-sm font-medium p-2' : 'hidden'}`}
                      className="flex items-center w-full  hover:bg-gray-100 text-sm font-medium p-2"
                      onClick={() => {
                        showModal({
                          component: 'ResetPinOtp',
                          modalProps: {
                            contentLabel: 'Wallet Pin Otp modal ',
                          },
                        });
                        handleMenuItemClick();
                      }}
                    >
                      <HiOutlineRefresh className="text-xl mr-4" />
                      Reset Wallet Pin
                    </button>
                    {/* <Link
                    className="flex hover:bg-gray-100 items-center text-sm font-medium p-2"
                    to="/wallet"
                  >
                    <HiOutlinePencilAlt className="text-xl mr-4" />
                    Change Wallet Pin
                  </Link>
                  <Link
                    className="flex hover:bg-gray-100 items-center text-sm font-medium p-2"
                    to="/wallet"
                  >
                    <HiOutlineRefresh className="text-xl mr-4" />
                    Reset Wallet Pin
                  </Link> */}
                  </>
                ) : (
                  <Link
                    className="flex hover:bg-gray-100 items-center text-sm font-medium p-2"
                    to="/verify-otp"
                  >
                    <FiShield className="text-xl mr-4" />
                    Verify Account
                  </Link>
                )}

                <button
                  type="button"
                  aria-label="logout"
                  // className={`${!clicked ? 'flex hover:bg-gray-100 items-center text-sm font-medium p-2' : 'hidden'}`}
                  className="flex items-center w-full  hover:bg-gray-100 text-sm font-medium p-2"
                  onClick={() => logOut()}
                >
                  <IoLogOutOutline className="text-xl mr-4" />
                  Logout
                </button>
              </div>
            </Dropdown>
          </div>
        ) : (
          <Link
            to="/sign-in"
            style={{ borderRadius: 4 }}
            className="w-auto mb-0 whitespace-nowrap overflow-hidden overflow-ellipsis bg-transparent font-medium lg:font-normal lg:bg-primary border-primary border-none sm:border text-sm text-primary lg:text-white p-3 flex justify-center"
          >
            Sign In/Sign Up
          </Link>
        )}
      </div>
    </nav>
  );
};

export default AuthHeaderMenu;
